// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"0b4347cc","23":"4de09faa","41":"95618687","78":"79698ac3","135":"65089002","180":"80258ca2","237":"c14c1a1d","254":"3fc761b3","265":"c0bb2dfa","521":"ad4e136c","636":"fb412d6e","687":"10a15fe7","804":"0481c476","877":"3229c77f"}[chunkId] + ".chunk.js";
};